import React from "react";
import FeedSectionView from "src/pages/section/FeedSection/view";

export interface FeedSectionVideoProps {
    defaultVideoSrc?: string;
    tabletVideoSrc?: string;
}


function FeedSection(props:FeedSectionVideoProps) {
    const defaultVideoSrc = "/videos/video_feed.mp4";
    const tabletVideoSrc = "/videos/video_feed_mob.mp4";


    return <FeedSectionView
        {...props}
        defaultVideoSrc={defaultVideoSrc}
        tabletVideoSrc={tabletVideoSrc}
    />
}

export default FeedSection;